import { Component } from 'react';
import { Icon } from '../Icon/Icon';
import { Tooltip } from '../Tooltip/Tooltip';
import { StepElement, StepperElement, StepsElement, StepWrapperElement } from './Stepper.styles';

export interface IStep {
  label: string;
}

export interface IProps {
  currentStep?: number;
  steps: IStep[];
  selectable?: boolean;
  onChange?: (currentStep: number) => void;
}

export class Stepper extends Component<IProps> {
  public render() {
    const { currentStep, steps, selectable } = this.props;
    return (
      <StepperElement>
        <StepsElement>
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const activeStep = stepNumber === currentStep;
            const ticked = currentStep != null && stepNumber < currentStep;
            return (
              <StepWrapperElement key={index} data-testid="StepWrapperElement">
                <Tooltip position="top" title={step.label} distance={18}>
                  <StepElement
                    active={activeStep}
                    data-active={activeStep}
                    selectable={selectable}
                    ticked={ticked}
                    onClick={() => {
                      if (selectable && this.props.onChange) {
                        this.props.onChange(stepNumber);
                      }
                    }}
                  >
                    {ticked ? <Icon icon="check" /> : <span>{stepNumber}</span>}
                  </StepElement>
                </Tooltip>
              </StepWrapperElement>
            );
          })}
        </StepsElement>
      </StepperElement>
    );
  }
}
